<template>
  <div>
    <div class="corner-form__toggler" @click="toggleMapFilter">
      {{locales && locales.filters && locales.filters.filter}}
    </div>

    <div class="map"></div>

    <div class="corner-form" v-if="isMapFilterOpen">
      <input class="corner-form__textfield" type="text" ref="address" @change="codeAddress" :placeholder="locales && locales.filters && locales.filters.location">
      <button class="corner-form__button" @click="codeAddress">Search!</button>
    </div>

    <button id="closeMapBtn"
            class="map-fancybox fancybox-button fancybox-button--close"
            title="Close"
            @click="closeMapExitFullscreen">
    </button>

  </div>
</template>

<script>
  import querystring from 'querystring';
  import { mapGetters, mapActions } from "vuex";

  export default {
    data() {
      return {
        nearby: null,
        map: null,
        infoWindow: new google.maps.InfoWindow({ maxWidth: 500 }),
        googleMarkers: [],
        windowWidth: 0,
        filterShowed: true
      };
    },
    computed: {
      ...mapGetters(["locales"]),
      isMapFilterOpen() {
        return this.$store.getters.getMapFilterState;
      },
      coordinates() {
        return this.$store.getters.getMapCoordinates;
      },
      markers() {
        return this.$store.getters.getMapMarkers;
      }
    },
    props: {
      websiteId: {
        default: 2,
        type: Number
      }
    },
    methods: {
      ...mapActions([
        'toggleMapFullscreen',
        'closeMapExitFullscreen',
        'toggleMapFilter',
        'showMapFilter',
        'hideMapFilter'
      ]),
      codeAddress() {
        window.axios
          .get(
            '/api/map-searches?' +
            querystring.stringify({
              map: 1,
              searchLocation: this.$refs.address.value
            })
          )
          .then(response => {
            if (response.data.center !== 'undefined') {
              var pt = new google.maps.LatLng(response.data.center.lat, response.data.center.lng);
              this.map.setCenter(pt);
            }
            let markers = [];

            _.each(response.data.searches, search => {
              let marker = {
                latitude: parseFloat(search.latitude),
                longitude: parseFloat(search.longitude),
                information: search.map_marker
              };

              markers.push(marker);
            });

            this.$store.commit('SET_MAP_MARKERS', markers);

          });
      },
      setMarker(marker) {
        if (this.websiteId == "2") {
          var image = {
            url: '/images/pin-blue.png',
            size: new google.maps.Size(40, 43),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(20, 43)
          };
        } else {
          var image = {
            url: '/images/pin-green.png',
            size: new google.maps.Size(40, 43),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(20, 43)
          };
        }

        var marker = new google.maps.Marker({
          position: { lat: marker[1], lng: marker[2] },
          map: this.map,
          icon: image,
          title: marker[0],
          html: marker[3],
        });
        var contentWindow = this.infoWindow;
        marker.addListener("click", function () {
          contentWindow.setContent(this.html);
          contentWindow.open(this.map, this);
        });

        return marker;
      },
      handleResize(event) {
        this.windowWidth = document.documentElement.clientWidth;
        let cornerForm = document.querySelector('.corner-form');
        if (this.windowWidth <= 768 && this.filterShowed == true) {
          this.$store.dispatch('hideMapFilter');
          this.filterShowed = false;
        } else if (this.windowWidth > 768 && this.filterShowed == false) {
          this.$store.dispatch('showMapFilter');
          this.filterShowed = true;
        }
      }
    },
    mounted() {

      if (this.detail) {
        var w_zoom = 11,
          w_lon = 0,
          w_lat = 0;
      } else {
        if (this.websiteId == "2") {
          var w_lat = 51.795027225829145,
            w_lon = 5.537109375,
            w_zoom = 8;
        } else {
          var w_lat = 51.924420,
            w_lon = 4.477733,
            w_zoom = 12;
        }
      }

      this.map = new google.maps.Map(document.querySelector('.map'), {
        zoom: w_zoom,
        maxZoom: 16,
        center: new google.maps.LatLng(w_lat, w_lon),
        mapTypeControl: false,
        mapTypeControlOptions: { style: google.maps.MapTypeControlStyle.DROPDOWN_MENU, position: google.maps.ControlPosition.RIGHT_BOTTOM },
        navigationControl: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        streetViewControl: true,
        fullscreenControl: true
      });

      this.codeAddress(this.map, 'Netherlands');

      this.$nextTick(function () {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
      });

      google.maps.event.addListenerOnce(this.map, 'idle', function () {
        document.querySelector('.gm-style').appendChild(document.getElementById('closeMapBtn'));

        if (window.outerWidth < 767) {
          let selector = document.querySelector('.map');
          selector.classList.add('trigger-map');
        }
      });
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.getWindowWidth);
    },
    watch: {
      coordinates() {
        if (!this.map) {
          return;
        }

        this.map.setCenter({
          lat: this.coordinates.latitude,
          lng: this.coordinates.longitude
        });
      },
      markers(collection) {
        if (!this.map) {
          return;
        }

        for (var i = this.googleMarkers.length - 1; i >= 0; i--) {
          this.googleMarkers[i].setMap(null);
          this.googleMarkers.splice(i, 1);
        }

        let markers = [];

        _.each(collection, marker => {
          this.googleMarkers.push(
            this.setMarker([marker.name, marker.latitude, marker.longitude, marker.information])
          );
        });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/MapSearches.vue